<template>
  <div class="pageContent">
    <el-row class="blod">证书基本信息</el-row>
    <el-row :span="24" v-if="certDetail" class="colContent">
        <template v-for="(item,index) in dataList" >
          <el-col :span="index == (dataList.length -1) ? 24:8" class="outCol" :key="index">
            <el-col :span="index == (dataList.length -1) ? 4:12">{{item.name}}
            </el-col>
            <el-col :span="index == (dataList.length -1) ? 20:12" class="flex ">
               <el-tooltip v-if="item.value.length > 30 && index !== (dataList.length -1)" :content="item.value" placement="top" effect="light">
                  <div class="ellipsis">{{item.value}}</div>
               </el-tooltip>
                <div v-else class="ellipsis">{{item.value}}</div>
              <span class="btn" @click="copy(`${item.value}`)" v-if="item.name==='证书ID' || item.name==='签发者'">复制</span>
            </el-col>
          </el-col>
        </template>
        <!-- <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col> -->
    </el-row>
  </div>
</template>
<script>
import { copy } from '@/utils'
export default {
  props: ['certDetail'],
  data () {
    return {
      dataList: [
      ]
    }
  },
  methods: {
    copy (val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    }
  },
  created () {
    console.log(' this.certDetail:', this.certDetail)
    this.dataList = [
      { name: '证书名称', value: this.certDetail.certName },
      { name: '过期时间', value: this.certDetail.expiredTime },
      { name: '生效时间', value: this.certDetail.effectTime },
      { name: '证书ID', value: this.certDetail.certId },
      { name: '注册时间', value: this.certDetail.registerTime },
      { name: '签发者', value: this.certDetail.issuer },
      { name: '主题', value: this.certDetail.theme }
    ]
  }
}
</script>
<style lang="less" scope>
.pageContent{
  .blod{
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #373d41;
  }
  .colContent{
    color: #73777a;
     border-top: 1px solid #ecedee;
      border-left: 1px solid #ecedee;
    .outCol{
      .el-col{
        border-right: 1px solid #ecedee;
        border-bottom: 1px solid #ecedee;
        line-height: 50px;
        height: 50px;
        padding-left: 10px;
        &:nth-child(odd){
          background-color: #fbfbfc;
        }
      }
    }
    .btn{
       color: rgb(0, 112, 204);
      margin-left: 10px;
      cursor: pointer;
      font-size: 10px;
    }
  }
  .el-icon-question{
      margin-left: 5px;
      color: rgb(204, 204, 204);
    }
    .flex{
      display: flex;
      white-space: nowrap;
      padding-right: 10px;
    }
}
</style>
